import Layout from 'shared/layout/Layout'
import { Sidebar } from 'widgets/Sidebar'

export const SidebarLayout = () => <Layout sidebarSlot={<Sidebar />} />
